import React, { useEffect } from "react";

import { State } from "../../../enums";
import { NotAllowedButtonAudio } from "../../NotAllowedButton/NotAllowedButtonAudio";
import { AudioPlayerPreviewButton } from "../AudioPlayerPreviewButton";

export const NonPlayableAudio = ({
  setPlayerApiSimple,
  state
}: {
  setPlayerApiSimple: () => void;
  state: State;
}) => {
  useEffect(() => {
    setPlayerApiSimple();
  }, [setPlayerApiSimple]);

  if (state === State.NOT_ALLOWED_CHANNEL || state === State.NOT_ALLOWED) {
    return <NotAllowedButtonAudio />;
  }

  return <AudioPlayerPreviewButton state={state} />;
};
